var $ = jQuery;

var developmentMode = true;
var simulateAjaxDelay = 0;
var jsCommand = {};

/********************************** Helpers ***********************************/
if (typeof $.fn.areYouSure !== "undefined") {
	if (typeof $.fn.areYouSure.defaults === "undefined") {
		$.fn.areYouSure.defaults = {};
	}
}

function bind(callback, toObject) {
	return function () {
		return callback.apply(toObject, arguments);
	};
}

function extend(child, parent) {
	var F = function () {
	};
	F.prototype = parent.prototype;
	child.prototype = new F();
	child._superClass = parent.prototype;
	child.prototype.constructor = child;
}

/******************************* Snippet update *******************************/
var SnippetUpdater = function () {
	var all = {};
	var snippets = {};

	this.add = function (snippet, name, callback) {
		if (typeof callback === "undefined") {
			callback = name;
			name = snippet;
			snippet = "all";
		}
		if (typeof callback !== "function") {
			console.error("Expected function as callback, given:", callback);
		}
		if (snippet === "all") {
			all[name] = callback;
		} else {
			if (typeof snippets[snippet] === "undefined") {
				snippets[snippet] = {};
			}
			snippets[snippet][name] = callback;
		}
	};

	this.remove = function (snippet, name) {
		if (typeof name === "undefined") {
			name = snippet;
			snippet = "all";
		}
		if (snippet === "all") {
			delete all[name];
		} else {
			if (typeof snippets[snippet] !== "undefined") {
				delete snippets[snippet][name];
			}
		}
	};

	this.execute = function (snippet) {
		var $element = $(typeof snippet === "object" ? snippet : '#' + snippet);
		for (var i in all) {
			all[i].call($element);
		}
		var callbacks = typeof snippets[snippet] === "string" ? snippets[snippet] : [];
		for (var i in callbacks) {
			callbacks[i].call($element);
		}
	};
};
var snippetOnUpdate = new SnippetUpdater(), snippetBeforeUpdate = new SnippetUpdater();

/******************************* Toastr setting *******************************/
toastr.options = {
	"closeButton": true,
	"debug": false,
	"newestOnTop": true,
	"progressBar": true,
	"positionClass": "toast-bottom-right",
	"preventDuplicates": true,
	"onclick": null,
	"showDuration": 300,
	"hideDuration": 1000,
	"timeOut": 10000,
	"extendedTimeOut": 10000,
	"showEasing": "swing",
	"hideEasing": "linear",
	"showMethod": "fadeIn",
	"hideMethod": "fadeOut"
};

/***************************** Nette + jQuery Ajax ****************************/
$.nette = {
	success: function (data, textStatus, jqXHR) {
		var payload = data;
		if (developmentMode && simulateAjaxDelay) {
			var t = Date.now();
			while (Date.now() < t + simulateAjaxDelay)
				;
		}

		developmentMode && console.log("Payload", payload ? payload : null);

		if (payload.redirect) {
			$('form').removeClass('dirty');

			window.location.href = payload.redirect;
			return;
		}

		if (payload.state) {
			$.nette.state = payload.state;
		}

		$.nette.processSnippets(payload.snippets);

		// change URL (requires HTML5)
		if ($.nette.href && $.nette.href != location.href) {
			if (window.history && history.pushState) {
				history.pushState({href: $.nette.href}, '', $.nette.href);
			}
		}
		$.nette.href = null;

		$.nette.processJsExecute(payload.jsExecute);

		$.nette.processFlashes(payload.flashes);
	},
	error: function (jqXHR, textStatus, errorThrown) {

	},
	complete: function (jqXHR, textStatus) {

	},
	processSnippets: function (snippets) {
		if (snippets && typeof snippets === 'object') {
			for (var id in snippets) {
				$.nette.updateSnippet(id, snippets[id]);
			}
		}
	},
	updateSnippet: function (id, html) {
		snippetBeforeUpdate.execute(id);

		$('#' + id).html(html);

		snippetOnUpdate.execute(id);
	},
	processJsExecute: function (jsExecute) {
		if (jsExecute && typeof jsExecute === 'object') {
			for (var i in jsExecute) {
				var execute = jsExecute[i], command = execute.command, args = execute.args, fnc;
				if (command && (fnc = jsCommand[command])) {
					if (developmentMode && command !== 'logException') {
						console.log(command, args);
					}
					args && typeof args === 'object' ? fnc.apply(undefined, args) : fnc();
				}
			}
		}
	},
	processFlashes: function (flashes) {
		if (flashes && typeof flashes === 'object') {
			for (var i in flashes) {
				var flash = flashes[i];
				toastr[flash.type](flash.message);
			}
		}
	},
	ajaxLinkCallback: function (event) {
		event && event.preventDefault();
		if ($.active) {
			return;
		}
		$.nette.ajaxLink(this);
	},
	ajaxLink: function (target) {
		var $target = $(target);

		$.nette.ajax({
			url: $target.attr('href'),
			track: !$target.hasClass('dont-track'),
			spinner: $.nette.findSpinner($target),
			spinnerMessage: $target.data('spinner-message'),
			success: function (data, textStatus, jqXHR) {
				eval($target.data('success'));
			},
			error: function (jqXHR, textStatus, errorThrown) {
				eval($target.data('error'));
			},
			complete: function (jqXHR, textStatus) {
				eval($target.data('complete'));
			}
		});
	},
	ajax: function (setting) {
		if (setting.track) {
			$.nette.href = setting.url;
			if (typeof window.onbeforeunload === 'function') {
				var ret = window.onbeforeunload();
				if (typeof ret === 'string' && !confirm(ret)) {
					$.nette.href = null;
					return;
				}
			}
		}

		if (setting.spinner) {
			setting.spinner = $(setting.spinner);
			setting.spinner.find('.spinner-text').text(setting.spinnerMessage ? setting.spinnerMessage : null);
			setting.spinner.removeClass('hidden');
		}

		$.ajax({
			type: 'POST',
			url: setting.url,
			success: function () {
				$.nette.success.apply(this, arguments);

				typeof setting.success === 'function' && setting.success.apply(this, arguments);
			},
			error: function () {
				$.nette.error.apply(this, arguments);

				typeof setting.error === 'function' && setting.error.apply(this, arguments);
			},
			complete: function () {
				$.nette.complete.apply(this, arguments);

				typeof setting.complete === 'function' && setting.complete.apply(this, arguments);

				setting.spinner && setting.spinner.addClass('hidden');
			}
		});
	},
	findSpinner: function ($this) {
		var spinner = $this.data('spinner');
		if (!spinner) {
			spinner = $this.find('.spinner');
			spinner = spinner.length ? spinner[0] : null;
		}
		if (!spinner) {
			spinner = $this.parents('.has-spinner');
			if (spinner.length) {
				spinner = $(spinner[0]).find('.spinner');
				spinner = spinner.length ? spinner[0] : null;
			} else {
				spinner = null;
			}
		}
		return spinner ? spinner : '#global-spinner';
	},
	ajaxFormCallback: function (event) {
		event.preventDefault();
		var form = this.form || this;
		var $form = $(form);
		if (event.stopPropagation) {
			event.stopPropagation();
		}

		form.action = location.href;

		if ($form.hasClass('prevent-double-submit') || !$form.hasClass('novalidate') && !Nette.validateForm(form, false, true)) {
			return false;
		}

		$form.addClass('prevent-double-submit');

		var spinner = $($.nette.findSpinner($form));
		var message = $form.data('spinner-message');
		spinner.find('.spinner-text').text(message ? message : null);
		spinner.removeClass('hidden');

		var data = {};
		if (this.type === 'submit') {
			data[this.name] = this.value;
		}
		console.log(this);
		console.log(data);

		var ajaxSetup = $.ajaxSetup();
		$form.ajaxSubmit({
			data: data,
			success: function () {
				var perform = ajaxSetup.success;
				typeof perform === 'function' && perform.apply(this, arguments);

				spinner.addClass('hidden');

				$form.removeClass('prevent-double-submit');
			},
			error: function () {
				var perform = ajaxSetup.error;
				typeof perform === 'function' && perform.apply(this, arguments);

				spinner.addClass('hidden');

				$form.removeClass('prevent-double-submit');
			},
			complete: ajaxSetup.complete
		});
	},
	state: null,
	href: null
};

$.ajaxSetup({
	success: $.nette.success,
	error: $.nette.error,
	complete: $.nette.complete,
	dataType: 'json'
});

/************************** Confirm features *************************/
snippetOnUpdate.add('confirm', function () { // Must be before AJAX feature !!!
	var $this = $(this);

	var cf = function (event) {
		if (!confirm(this.dataset.confirm)) {
			event.stopImmediatePropagation();
			event.preventDefault();
		}
	};

	$this.find('a[data-confirm], form[data-confirm] :submit, button[data-confirm]').each(function () {
		var $this = $(this);
		$this.parents('.dataTables_wrapper').length || $this.on('click', cf);
	});
	$this.find('form[data-confirm]').each(function () {
		var $this = $(this);
		$this.parents('.dataTables_wrapper').length || $this.on('submit', cf);
	});

	$this.find('.dataTables_wrapper tbody')
		.on('click', 'a[data-confirm], form[data-confirm] :submit, button[data-confirm]', cf)
		.on('submit', 'form[data-confirm]', cf);
});

/*************************** AJAX features ***************************/
snippetOnUpdate.add('ajax', function () {
	var $this = $(this);

	$this.find('a.ajax').each(function () {
		var $this = $(this);
		$this.parents('.dataTables_wrapper').length || $this.on('click', $.nette.ajaxLinkCallback);
	});
	$this.find('form.ajax').each(function () {
		var $this = $(this);
		$this.parents('.dataTables_wrapper').length || $this.on('submit', $.nette.ajaxFormCallback);
	});
	$this.find('form.ajax :submit').each(function () {
		var $this = $(this);
		$this.parents('.dataTables_wrapper').length || $this.on('click', $.nette.ajaxFormCallback);
	});

	$this.find('.dataTables_wrapper tbody')
		.on('click', 'a.ajax', $.nette.ajaxLinkCallback)
		.on('submit', 'form.ajax', $.nette.ajaxFormCallback)
		.on('click', 'form.ajax :submit', $.nette.ajaxFormCallback);
});

/*************************** Nette Input validation ***************************/
snippetOnUpdate.add('nette-input-validation', function () {
	var $this = $(this);

	var vf = function () {
		if (Nette.validateControl(this, undefined, false, undefined, false)) {
			var $elem = $(this);
			$($elem.parents('.form-group')[0]).removeClass('has-error');
			var id = $elem.attr('id');
			if (id) {
				$($("label[for='" + id + "']").parents('.form-group')[0]).removeClass('has-error');
			}
		}
	};

	$this.find(':not(.dataTables_wrapper) :input').each(function () {
		var $this = $(this);
		$this.parents('.dataTables_wrapper').length || $this.on('blur focus keyup change', vf);
	});

	$this.find('.dataTables_wrapper')
		.on('blur focus keyup change', ':input', vf);
});

/****************************** Data Input Mask *******************************/
if (typeof Inputmask !== "undefined") {
	snippetOnUpdate.add('data-input-mask', function () {
		$(this).find("[data-inputmask]").inputmask();
	});

	Inputmask.extendAliases({
		"dd.mm.yyyy hh:mm": {
			mask: "1.2.y h:s",
			placeholder: "dd.mm.yyyy hh:mm",
			alias: "datetime",
			separator: '.'
		}
	});
}

/******************************* Are your sure ********************************/
if (typeof $.fn.areYouSure !== 'undefined') {
	snippetOnUpdate.add('are-you-sure', function () {
		var $this = $(this).find("form.are-you-sure")
			.areYouSure($.fn.areYouSure.defaults)
			.bind('dirty.areYouSure', function () {
				$(this).find('[type="submit"]').removeAttr('disabled');
			})
			.bind('clean.areYouSure', function () {
				$(this).find('[type="submit"]').attr('disabled', 'disabled');
			});

		$this.find('[type="submit"]').attr('disabled', 'disabled');

		$this.find('.moda').on('hidden.bs.modal', function () {
			$(this).find('form').each(function () {
				this.reset();
			});
		});
	});
}

/******************************* Toggle ********************************/
if (typeof $.fn.toggle !== 'undefined') {
	snippetOnUpdate.add('toggle', function () {
		$(this).find("input.toggle").each(function () {
			var $this = $(this).addClass('hidden');

			var $toggler = $('<div>')
				.addClass('toggle toggle-light' + ($this.is(':disabled') ? ' disabled' : ''))
				.css({
					width: '60px',
					marginTop: '8px'
				})
				.insertBefore($this)
				.toggles({
					checkbox: $this,
					on: $this.is(':checked')
				})
				.on('toggle', function () {
					$this.trigger('change');	// Due to Are-You-Sure
				})
				.data('toggles');
			$('label[for="' + $this.attr('id') + '"]').on('click', function (event) {
				event.preventDefault();
				$toggler.toggle();
			});
		});
	});
}

/******************************* WYSIHTML5 ********************************/
if (typeof $.fn.wysihtml5 !== 'undefined') {
	snippetOnUpdate.add('wysihtml5', function () {
		$(this).find(":input.wysiwyg").wysihtml5();
	});
}

/******************************* Toggle ********************************/
snippetOnUpdate.add('add-spinner', function () {
	var $spinner = $('<div class="overlay spinner hidden"><i class="fa fa-refresh fa-spin"></i></div>');

	var $this = $(this);
	if ($this.hasClass('has-spinner')) {
		$spinner.clone().appendTo($this);
	}
	$this.find('.has-spinner').each(function () {
		$spinner.clone().appendTo(this);
	});
});

/******************************* Select2 ********************************/
if (typeof $.fn.select2 !== 'undefined') {
	snippetOnUpdate.add('add-select2', function () {
		$(this).find('.select2').select2();
	});
}

/************************** Disable form autocomplete *************************/
snippetOnUpdate.add('disable-autocomplete', function () {
	$(this).find(':input').each(function () {
		var input = $(this);
		input.attr({
			"autocomplete": ("new-" + input.attr("name")),
			"autocorrect": "off",
		})
	});
});

/******************************* Onload process *******************************/
jQuery(function () {
	// Bind popstate with delay (safari bug)
	setTimeout(function () {
		$(window).bind('popstate', function () {
			$.get(location.pathname, $.nette.success);
		});
	}, 300);

	// Register Initizer
	if (typeof init === "undefined") {
		init = [];
	}
	var Initizer = function (init) {
		for (var k in init) {
			init[k]();
		}

		this.push = function (callback) {
			callback();
		};
	};
	init = new Initizer(init);

	// Register all features
	snippetOnUpdate.execute(document);
});


/******************************* Fix datatables on resize *******************************/
jQuery(function () {
	$(window).resize(function () {
		window.dtResizeTimer && clearTimeout(window.dtResizeTimer);

		window.dtResizeTimer = setTimeout(function () {
			var tables = jQuery.fn.DataTable.tables() || [];

			for (var i = 0; i < tables.length; i++) {
				jQuery(tables[i]).DataTable().columns.adjust().draw();
			}
		}, 500);
	});
});

jQuery(document).on('init.dt', function (e, s) {
	var $dt = jQuery(e.target).DataTable();
	var $container = jQuery($dt.table().container())
		.find(".dataTables_scrollHead, .DTFC_LeftHeadWrapper, .DTFC_RightHeadWrapper")
		.find("th.dt-col-visibility-control");

	if (!$container.length) {
		return;
	}

	// Col view
	var headers = $dt.columns().header();
	var $templateControl = $container.find("ul");
	for (var i = 0; i < headers.length - 1; i++) {
		var text = $(headers[i]).text();
		var column = $dt.column(i);

		jQuery('<li' + (column.visible() ? ' class="active"' : '') + '><a href="#" onclick="dtToggleColumn(event, ' + i + ')">' + text + '</a></li>')
			.appendTo($templateControl);
	}
});

dtToggleColumn = function (event, colNo) {
	event.preventDefault();
	event.stopPropagation();

	var $this = $(event.target),
		$dt = $this.parents(".dataTables_wrapper").find(".dataTables_scrollBody table").DataTable(),
		column = $dt.column(colNo),
		visible = !column.visible();

	column.visible(visible);

	jQuery($dt.table().container()).find("th.dt-col-visibility-control ul").each(function () {
		if (visible) {
			jQuery(jQuery(this).children()[colNo]).addClass("active");
		} else {
			jQuery(jQuery(this).children()[colNo]).removeClass("active");
		}
	});
};
